
import React from 'react';
import { CreditCard } from 'lucide-react';
import { formatCurrency } from '@/utils/formatters';

interface PaymentMethodSectionProps {
  finalAmount: number;
}

const PaymentMethodSection: React.FC<PaymentMethodSectionProps> = ({ finalAmount }) => {
  return (
    <div className="rounded-lg border p-4 bg-white shadow-sm">
      <div className="flex mb-2">
        <CreditCard className="h-5 w-5 mr-2 text-blue-600" />
        <h4 className="font-medium">Payment Method</h4>
      </div>
      <p className="text-sm mb-2">Your saved payment method will be charged ${formatCurrency(finalAmount)}</p>
      <div className="flex items-center p-3 bg-gray-50 border rounded-md">
        <div className="w-10 h-6 bg-blue-600 rounded mr-2"></div>
        <span className="font-medium">•••• •••• •••• 4242</span>
      </div>
    </div>
  );
};

export default PaymentMethodSection;
